module.exports = __webpack_public_path__ + "img/Nav-btn.c883cf88.svg";